/**
 * @file
 * Persistent pseudo filter handler for ViewsReference filters.
 *
 * Handles pseudo filters that are rendered outside the exposed form.
 */

(function ($, Drupal, once) {
  'use strict';

  /**
   * PersistentPseudoFilterHandler class for ViewsReference filters.
   * Handles pseudo filters that are rendered outside the exposed form.
   */
  class PersistentPseudoFilterHandler extends window.PseudoFilterHandler {

    /**
     * Constructor.
     *
     * @param {HTMLElement} container - The persistent filter container.
     * @param {Object} settings - The settings object.
     */
    constructor(container, settings) {
      // Find the first pseudo-filter-wrapper within the container.
      const wrapper = container.querySelector('.pseudo-filter-wrapper');
      super(wrapper || container, settings);

      this.container = container;
      this.viewId = settings.viewId;
      this.displayId = settings.displayId;
      this.isViewsReference = settings.isViewsReference || false;

      // For ViewsReference, we need to find the associated view container.
      if (this.isViewsReference) {
        const wrapperId = this.container.id;
        this.viewContainer = document.querySelector(`[data-viewsreference-content="${wrapperId}"]`);
      }
    }

    /**
     * Find the corresponding hidden exposed filter.
     * Override to use view instance ID for matching.
     */
    findRealFilter() {
      const viewInstance = this.wrapper.dataset.viewInstance;

      if (!viewInstance) {
        return;
      }

      // Only search within the same view instance
      const selector = `[data-view-instance="${viewInstance}"][data-pseudo-filter="${this.filterId}"]`;
      this.realFilter = document.querySelector(selector);
    }

  }

  // Export to window for global access
  window.PersistentPseudoFilterHandler = PersistentPseudoFilterHandler;

})(jQuery, Drupal, once);
